( function () {
   
    'use strict';

    ( function ( $ ) {
        
        $(".match-tab").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".match-tab").removeClass('active');
              $(this).addClass('active');
              $(".match-tab-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $(".scorecard-team").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".scorecard-team").removeClass('active');
              $(this).addClass('active');
              $(".scorecard-team-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $(".team-innings-one").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".team-innings-one").removeClass('active');
              $(this).addClass('active');
              $(".team-innings-content-one").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $(".team-innings-two").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".team-innings-two").removeClass('active');
              $(this).addClass('active');
              $(".team-innings-content-two").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $(".team-innings-three").click(function () {
          if ($(this).hasClass('active')) {
          } else {
            var tabid = $(this).attr('id');
            $(".team-innings-three").removeClass('active');
            $(this).addClass('active');
            $(".team-innings-content-three").removeClass('active');
            $("#" + tabid + "-content").addClass("active");
          }
          return false;
      });
      $(".team-innings-four").click(function () {
        if ($(this).hasClass('active')) {
        } else {
          var tabid = $(this).attr('id');
          $(".team-innings-four").removeClass('active');
          $(this).addClass('active');
          $(".team-innings-content-four").removeClass('active');
          $("#" + tabid + "-content").addClass("active");
        }
        return false;
    });
    $(".team-innings-five").click(function () {
      if ($(this).hasClass('active')) {
      } else {
        var tabid = $(this).attr('id');
        $(".team-innings-five").removeClass('active');
        $(this).addClass('active');
        $(".team-innings-five-content").removeClass('active');
        $("#" + tabid + "-content").addClass("active");
      }
      return false;
    });
    $(".team-innings-six").click(function () {
      if ($(this).hasClass('active')) {
      } else {
        var tabid = $(this).attr('id');
        $(".team-innings-six").removeClass('active');
        $(this).addClass('active');
        $(".team-innings-six-content").removeClass('active');
        $("#" + tabid + "-content").addClass("active");
      }
      return false;
    });
        $(".player-team-list").click(function () {
          if ($(this).hasClass('active')) {
          } else {
            var tabid = $(this).attr('id');
            $(".player-team-list").removeClass('active');
            $(this).addClass('active');
            $(".player-team-list-content").removeClass('active');
            $("#" + tabid + "-content").addClass("active");
          }
          return false;
      });
        $('.popup-blog-video').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
              open: function() {
                $("body").addClass("overflow");
                $(this.content).find('video')[0].play();
             },
              close: function() {
                $("body").removeClass("overflow");
                jQuery(this.content).find('video')[0].pause();
              }
            }
        });
      $('.popup-youtube').magnificPopup({
        type: 'iframe'
      });
     

    } )( jQuery );
} )();

